module.exports = __webpack_public_path__ + "img/img3.a4d633cb.svg";